<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
      <img src="/static/img/image2vector.svg" alt="Logo" class="img-responsive center-block logo" style="background: none; filter: invert(1)">  
      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a id="toggle-menu" href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button" @click="barra">
          <span class="sr-only">Toggle navigation</span>
        </a>

        <!-- <div class="modelSelect">
          <model-select 
            :options="options"
            v-model="item"
            placeholder="Empresa">
         </model-select>
        </div> -->
        <div class="modelSelect" v-if="config.funcionamento==='manual'"> 
          <div class="row" > 
            <span v-show="!bot_ativo" style="color: white;">BOT DESLIGADO</span>
            <span v-show="bot_ativo" style="color: white">BOT LIGADO</span>
          </div>
          <div class="row">
            <toggle-button 
              @change="alteraStatusBot"
              v-model="bot_ativo"
              :color="color" 
              :sync="true" 
              :labels="true"/>
          </div>
        </div>

        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">

          <ul class="nav navbar-nav">
              
            <!-- Notifications Menu
            <li class="dropdown notifications-menu">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-bell-o"></i>
                <span class="label label-warning">{{ userInfo.notifications | count }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ userInfo.notifications | count }} notification(s)</li>
                <li v-if="userInfo.notifications.length > 0">
                  Inner Menu: contains the notifications
                  <ul class="menu">
                    <li>
                      start notification
                      <a href="javascript:;">
                        <i class="fa fa-users text-aqua"></i> 5 new members joined today
                      </a>
                      <a href="javascript:;">
                        <i class="fa fa-users text-aqua"></i> 5 new members joined today
                      </a>
                    </li>
                    end notification
                  </ul>
                </li>
                <li class="footer" v-if="userInfo.notifications.length > 0">
                  <a href="javascript:;">View all</a>
                </li>
              </ul>
            </li> -->

            <!-- liga e desliga bot -->
            <li class="notifications-menu status-bot">
              
            </li>
          
            
            <!-- User Account Menu -->
            <li class="dropdown user user-menu notifications-menu">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <!-- The user image in the navbar-->
                <img v-bind:src="demo.avatar" class="user-image" alt="User Image">
                <!-- hidden-xs hides the username on small devices so only the image appears. -->
                <span class="hidden-xs">Olá, {{ demo.displayName }}</span>
              </a>
              <ul class="dropdown-menu animated slideInDown" style="animation-duration: 0.5s;">
                <!--<li class="header">Olá {{demo.displayName}}</li>-->
                <li >
                  <ul class="menu">
                    <li>
                      <a href="javascript:;" @click="minhaConta">
                        <i class="fa fa-user text-aqua"></i> Minha Conta
                      </a>
                      <a href="javascript:;" @click="novoUsuario">
                        <i class="fa fa-user-plus text-aqua"></i> Novo Usuário
                      </a>
                      <a href="javascript:;" @click="logout">
                        <i class="fa fa-sign-out text-aqua"></i> Sair
                      </a>
                    </li>
                  </ul>
                </li>
                <!--<li class="footer" v-if="userInfo.notifications.length > 0">
                  <a href="javascript:;">View all</a>
                </li>-->
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName" :picture-url="demo.logo" :empresa="demo.empresa"/>
  
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          {{$route.name.toUpperCase() }}
          <small>{{ $route.meta.description }}</small>
        </h1>
        <ol class="breadcrumb">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>Home</a>
          </li>
          <li class="active">{{$route.name.toUpperCase()}}</li>
        </ol>
      </section>
  
      <router-view></router-view>
    </div>

    <audio src="/static/audio/alerta.mp3" loop>
      O seu navegador não suporta o elemento <code>audio</code>.
    </audio>

    <!-- modal de visualizaçao pedido-->     
    <div v-if="modal" id="pedido" style="display: none" v-for="(linha, index) in pedidosImprimir">
      <modal-pedido :index="index" :linha="linha"></modal-pedido>
    </div>
    <!-- /.content-wrapper -->
   <beautiful-chat v-if="mostrar"
          @sendMsg="sendMessage"
          @leuMsg="leuMsg"
          @atualizarImagem="atualizarImagem"
          @backChat="getMessages"
          :escolheuCliente="escolheuCliente"
          :mensagens="mensagens"
          :onMessageWasSent="onMessageWasSent"
          :newMessagesCount="newMessagesCount"
          :isOpen="isChatOpen"
          :close="closeChat"
          :open="openChat"
          :showEmoji="true"
          :showFile="true" />
    <!-- Main Footer -->
    <footer class="main-footer">
      <strong>Copyright &copy; {{year}}
        <a href="https://sevsolucoes.com">SEV</a>.</strong> All rights reserved.
    </footer>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import config from '../config'
import Sidebar from './Sidebar'
import firebase from 'firebase'
import axios from 'axios'
import { ModelSelect } from 'vue-search-select'
import ModalNovoPedido from './views/ModalNovoPedido'
import 'hideseek'
import Pusher from "pusher-js"; // import Pusher

export default {
  name: 'Dash',
  components: {
    Sidebar,
    ModelSelect,
    'modal-pedido': ModalNovoPedido
  },
  data: function () {
    return {
      messageList: [],
      newMessagesCount: 0,
      isChatOpen: false,
      mensagens: [],
      mostrar: false,
      escolheuCliente: false,
      url: this.$store.state.api,
      // section: 'Dash',
      config: [],
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: '',
      logo: true,
      bot_ativo: this.$store.state.bot_ativo,
      color:{checked: '#00A65A', unchecked: '#FF0000'},
      options: [],
      item: {
        text: '',
        values: 0
      },
      modal: false,
      pedidosImprimir: [],
      cont: 0
    }
  },
  created(){
    this.getConfig()
    this.getMessages()
    // this.alertTeste()
    // this.getNovosPedidos()
    if(this.$store.state.permite_impressao) {
      this.verificaPedido()
    }
  },
  mounted() {
    if(!this.isMobile)
      document.getElementById('toggle-menu').click()
      let barraRecolhida = document.getElementsByClassName('sidebar-collapse')
      if (barraRecolhida.length === 1) {
        this.logo = false
      } else {
        this.logo = true
      }
  },
  computed: {
    demo () {
      return {
        displayName: this.$store.state.nome_usuario,
        empresa: this.$store.state.empresa,
        email: this.$store.state.email,
        avatar: this.$store.state.foto,
        logo: this.$store.state.logo
      }
    },
    isMobile () {
      console.log('is mobile? ', window.innerWidth <= 800 && window.innerHeight <= 600)
      console.log('width => ', window.innerWidth)
      console.log('height => ', window.innerHeight)
      return (window.innerWidth <= 500 && window.innerHeight <= 800)
    }
  },
  methods: {
    alertTeste() {
      alert(this.cont);
      setTimeout(() => {
        this.cont++;
        this.alertTeste()
      }, 2000);
    },
    verificaPedido() {
      Pusher.logToConsole = true;

      var pusher = new Pusher('6846a7777c4cdce67915', {
        cluster: 'us2',
        forceTLS: true
      });

      var channel = pusher.subscribe(`order${window.localStorage.getItem('FB_ID')}`);
      channel.bind('novo', (data) => {
        // alert(JSON.stringify(data));
        this.somNotificacao();
        this.getNovosPedidos();
      });

      var channelAgenda = pusher.subscribe(`agenda${window.localStorage.getItem('FB_ID')}`);
      channelAgenda.bind('novo', (data) => {
        console.log('novo agendamento --> ', data)
        alert('Novo agendamento realizado!');
      });
    },
    somNotificacao () {
      console.log('audio play')
      var v = document.getElementsByTagName("audio")[0];
      v.play();
    },
    pararSom() {
      console.log('audio pause')
      var v = document.getElementsByTagName("audio")[0];
      v.pause();
    },
    getNovosPedidos() {
      this.pedidosImprimir = []
      axios.get(`${this.$store.state.api}pedidos/novos?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        console.log('novos pedidos =======> ', response)
        this.$swal({
          title: 'Novo Pedido!',
          html: 'Você tem um novo pedido',
          type: 'success',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sair',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Imprimir'
        }).then((result) => {
          this.pararSom();
          if (result.value) {
            response.data.forEach((element, index, array) => {
              let itens = element.itensPedido
              let itens_pedido = []
              let prodName=''
              let qtde=0
              let obs= ''
              this.preco_total = element.preco_total
              for (var i = 0 ; i < itens.length; i++) {
                for (var j = 0; j < itens[i].itens.length; j++) {
                  if(prodName != '') prodName += '/ ' + itens[i].itens[j].produtos.nome
                  else prodName = itens[i].itens[j].produtos.nome

                  if(obs != '') obs += '/ ' + itens[i].itens[j].observacao 
                  else obs = itens[i].itens[j].observacao            
                }
                if(j > 1) qtde = 1
                else qtde = itens[i].itens[j-1].quantidade

                let massa = ''
                if(itens[i].tipo_massa) massa = ' - ' + itens[i].tipo_massa
                if(itens[i].tipo_borda) massa += ' / ' + itens[i].tipo_borda
                
                if(obs !== '') obs += massa
                else obs = massa
                if (obs !== '') prodName += ' (' + obs + ')'

                let nomeProduto;

                if(itens[i].cardapio && itens[i].cardapio.nome.indexOf('Pizza') != -1 ) nomeProduto = `${itens[i].cardapio.nome} - ${prodName}`;
                else nomeProduto = prodName;

                let descricao = '';
                if(this.config.imprimir_descricao) descricao = itens[i].itens[0].produtos.descricao ? itens[i].itens[0].produtos.descricao.split('.')[0] : ''

                let total = 0;

                itens[i].adicionais.forEach((adicional) => {
                  total += (adicional.preco * adicional.qtde)
                });

                total += itens[i].preco_item;

                itens_pedido.push({nome: nomeProduto, descricao, qtde: qtde, total, observacao: obs, preco: itens[i].preco_item, adicionais: itens[i].adicionais ? itens[i].adicionais : null})
                
                // itens_pedido.push({nome: prodName, qtde: qtde, observacao: obs, preco: itens[i].preco_item, adicionais: itens[i].adicionais})
                prodName = ''
                obs = ''
              }
              element.itensPedido = itens_pedido

              // element.formaPagamento.forEach((pagamento, index, array) => {
              //   if(pagamento.observacao) pagamento.observacao = 'Troco para R$'+ pagamento.observacao
              // })
              this.pedidosImprimir.push(element)
            })
            this.modal = true
            setTimeout(() => {
              for (let i in this.pedidosImprimir) {
                // console.log('pedidosImprimir-> ', this.pedidosImprimir[i])
                this.imprimiu(this.pedidosImprimir[i].id)
                this.imprimirPedidos(i)
                      // axios.post(this.$store.state.api+'pedidos/alter-status', {
                      //   'id_estado': 2,
                      //   'id_pedido': this.pedidosImprimir[i].id
                      // }).then(response => {
                      //   console.log('mudou status')
                      // })
                    
                  
              }
            },1500)
          }
        })
      })
    //  setTimeout(() => {
    //     this.getNovosPedidos()
    //   },30000)
    },
    imprimiu(id){
      axios.get(this.$store.state.api + 'pedidos/imprimiu?id=' + id)
    },
    imprimirPedidos (i) {
        console.log('imprimiu ', i)
        var title = document.getElementById('titlePedido' + i).innerHTML,
        endereco = document.getElementById('enderecoNovo'+ i).innerHTML,
        itens = document.getElementById('itensNovo'+ i).innerHTML,
        pagamento = document.getElementById('pagamentoNovo'+ i).innerHTML,
        tela_impressao = window.open('about:blank');

        tela_impressao.document.write(title);
        tela_impressao.document.write('<br>');      
        tela_impressao.document.write(endereco);      
        tela_impressao.document.write('<br><br>');      
        tela_impressao.document.write(itens);
        tela_impressao.document.write('<br><br>');      
        tela_impressao.document.write(pagamento);
        tela_impressao.document.write('<br><br>');      
        tela_impressao.document.write('<style> table {text-align: center} .lblEnd{margin-top:-1%} label {font-size: 12px!important;} tr {font-size: 12px;} th{font-size: 12px;} h4 {font-size: 12px; margin-bottom: 1%} p {font-size: 12px;} h5 {margin: 0px} .adicionais { font-size: 11px; margin: 0 } .bordaItem{ border-bottom: 1px dotted }</style>');      
        tela_impressao.window.print();
        tela_impressao.window.close();
    },
    getConfig () {
      axios.get(`${this.$store.state.api}config?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.config = response.data[0]
        console.log('config:',this.config)
        if (this.config.funcionamento==='manual') {
          if(this.$store.state.bot_ativo === undefined){
            // let url= this.$store.state.api_bot+'status'
            let url= `${this.$store.state.api_bot}status?empresa=${this.$store.state.empresa_fb_id}`
            axios.get(url).then(response => {
              let status = response.data.status
              
                this.$store.commit('ACTIVE_BOT', status)
                this.bot_ativo = status
            
            })
          } 
          else if(this.$store.state.bot_ativo) {
            this.bot_ativo = true
          } else {
            this.bot_ativo = false
          }
        }
      })
    },
    getMessages() {
      axios.get(`${this.url}mensagens?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.mensagens = [];
        this.newMessagesCount = 0;
        console.log(response.data)
        response.data.forEach(element => {
          let ajusteMsg = this.ajustaMsg(element.mensagens)
          this.mensagens.push({
            id: element.fb_id ? element.fb_id : element.facebook_id,
            nome: element.nome + ' ' + element.sobrenome, 
            img: element.url_foto,
            mensagem: ajusteMsg.msg,
            lido: ajusteMsg.lido
          })
        });
        if(this.newMessagesCount > 0 && this.$store.state.permite_email) this.enviarEmail()
        this.mostrar = true;
        this.orderCliente()
        setTimeout(() => {
          this.getMessages();
        }, 200000)
      })
    },
    orderCliente() {
      this.mensagens.sort(function(a, b) {
        var dataA = a.mensagem[a.mensagem.length-1].date;
        var dataB = b.mensagem[b.mensagem.length - 1].date;
        return (dataA > dataB) ? -1 : (dataA < dataB) ? 1 : 0;
      });
      console.log('clientes mensagens -> ', this.clientes)
    },
    ajustaMsg(mensagens) {
      let msg = [], lido = true;
      mensagens.forEach(element => {
        if(!element.lido) {
          lido = false;
          this.newMessagesCount++;
        }
        msg.push({
          author: element.autor,
          data: {
            text: element.mensagem
          },
          date: element.data_hora,
          type: 'text',
          lido: element.lido
        })
      });
      return { msg: msg, lido: lido};
    },
    enviarEmail() {
      axios.post('https://us-central1-sevsolucoes-44d04.cloudfunctions.net/enviarEmail', {
        'assunto': 'Novas Mensagens',
        'corpo': 'Olá, você possui ' + this.newMessagesCount + ' novas mensagens sem resposta.',
        'destinatario': this.$store.state.email
      }).then((res) => {
        console.log('retorno email -> ', res)
      })
    },
    sendMessage (msg) {
      console.log('msg back -> ', msg)
      if (msg.mensagem.length > 0) {
        let url= this.$store.state.api_bot+'pedidos/estado_pedido?fb_id='+msg.id+'&msg='+msg.mensagem+'&mostrar_botao='+true
        axios.get(url).then(response => console.log(response));
        this.gravaMsg(msg);
      }
    },
    gravaMsg(msg) {
      axios.post(`${this.url}mensagens`, {
        id: msg.id,
        data: msg.date,
        mensagem: msg.mensagem
      }).then((ret) => {
        console.log('retorno msg -> ', ret);
      }).catch((err) => {
        console.log('retorno msg -> ', err);
      })
    },
    leuMsg(id) {
      this.newMessagesCount = 0;
      axios.put(`${this.url}mensagens`, {
        id: id
      })
      this.mensagens.forEach(element => {
        if(element.id === id) {
          element.mensagem.forEach((msg) => {
            msg.lido = true
          })
          this.ajustaMsg(element.mensagem)
        }
      })
    },
    onMessageWasSent (msg) {
      // console.log('mensagem ', msg)
      // this.messageList.push(msg)
      // this.escolheuCliente = true
    },
    openChat () {
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat () {
      this.isChatOpen = false;
      this.escolheuCliente = false;
    },
    alteraStatusBot() {
        this.$store.commit('ACTIVE_BOT', this.bot_ativo)
        // let url= this.$store.state.api_bot+'status/active?status='+this.bot_ativo
        let url= `${this.$store.state.api_bot}status/active?status=${this.bot_ativo}&empresa=${this.$store.state.empresa_fb_id}`
        axios.get(url).then()
    },
    logout () {
      this.$swal({
        title: 'Tem certeza que deseja sair?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sair',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('logout')
          this.$router.replace('login')
        }
      })
    },
    minhaConta () {
      this.$router.push('minha-conta')
    },
    novoUsuario () {
      this.$router.push('novo-usuario')
    },
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    barra () {
      if (!this.isMobile) {
        // ajustar logo sev
        if (this.logo) {
          this.logo = false
        } else {
          this.logo = true
        }

        // nome empresa
        if (this.$store.state.show_empresa) {
          this.$store.commit('HIDDEN_EMPRESA')
        } else {
          this.$store.commit('SHOW_EMPRESA')
        }
      }
    },
    atualizarImagem(id) {
        console.log('atualizando imagem ', id)
        axios.get(`https://graph.facebook.com/v2.7/${id}?access_token=${this.$store.state.fb_page_token}`)
        .then((ret) => {
            this.updateCliente(ret.data);
        })
    },
    updateCliente(cliente) {
        axios.put(this.$store.state.api + 'clientes/' + cliente.id, {
            nome: cliente.first_name,
            sobrenome: cliente.last_name,
            url_foto: cliente.profile_pic,
            sexo: cliente.gender
        }).then((data) => {
            // this.$router.go()
        })
    }
  }
}
</script>

<style lang="scss">
.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: left;

  img {
    padding: .4em !important;
  }
}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width: 25%;
  }
}

.user-panel {
  height: 6em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}

.navbar-nav>.user-menu .user-image {
  width: 40px;
  height: 40px;
  margin-top: -10px;
}

.content-wrapper {
  min-height: 100vh!important;
}

.circle-active{
  font-size: 20px;
  color: green
}
.circle-disable{
  font-size: 20px;
  color: red
}

.status-bot{
    margin-top: 1%;
}

.modelSelect {
    margin-left: 48%;
    position: absolute;
    margin-top: 1px;
    text-align: center
}

</style>



// WEBPACK FOOTER //
// Dash.vue?90348a4e